import { Container, Stack } from '@rabex-kit/core';
import { Helmet } from 'react-helmet-async';
import { useResponsive, useTheme } from '@rabex-kit/rabex-ui';
import AuthHeader from '../AuthHeader';
import useGoftino from '../../hooks/useGoftino';
import CaptchaHost from '../CaptchaHost';

type LayoutProps = {
  title: string;
  children: JSX.Element | JSX.Element[];
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

const AuthLayout = ({ title, children, maxWidth = 'lg' }: LayoutProps) => {
  const { matches } = useResponsive();
  const theme = useTheme();
  const { palette } = theme;
  useGoftino();
  return (
    <Stack
      gap={{ lg: 8, xs: 6 }}
      // 100dvh: on mobile, 100vh includes the browser's address bar, so a long form (register)
      // ended under its toolbar. A min height lets the page grow and scroll instead.
      width="100%"
      minHeight="100dvh"
      bgcolor={palette.mode === 'light' ? palette.base[50] : palette.base[200]}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <AuthHeader />
      <Container maxWidth={maxWidth} sx={{ pt: matches({ xs: 16, lg: 0 }) }}>
        <Stack
          justifyContent="center"
          flexDirection="row"
          width="100%"
          gap={3}
          pt={{ xs: 0, lg: 10 }}
          pb={7}
          px={{ xs: 4, lg: 0 }}>
          {children}
        </Stack>
      </Container>
      {/* Login, register and forgot-password requests go through the captcha. */}
      <CaptchaHost />
    </Stack>
  );
};

export default AuthLayout;
